import { render, staticRenderFns } from "./QPendingPolicyDataTable.vue?vue&type=template&id=ce44e26a&scoped=true&"
import script from "./QPendingPolicyDataTable.vue?vue&type=script&lang=js&"
export * from "./QPendingPolicyDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QPendingPolicyDataTable.vue?vue&type=style&index=0&id=ce44e26a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce44e26a",
  null
  
)

export default component.exports